<p-button
  class="desktop"
  [label]="label"
  [loading]="loading"
  [disabled]="disabled"
  [severity]="severity"
  [rounded]="rounded"
  [raised]="raised"
  [variant]="variant"
  [badge]="badge"
  [badgeSeverity]="badgeSeverity"
  [size]="size"
  (onClick)="onClick.emit($event)"
  (onFocus)="onFocus.emit($event)"
  (onBlur)="onBlur.emit($event)"
>
  <mat-icon>{{ icon }}</mat-icon>
</p-button>

<p-button
  class="mobile"
  [loading]="loading"
  [disabled]="disabled"
  [severity]="severity"
  [rounded]="rounded"
  [raised]="raised"
  [variant]="variant"
  [badge]="badge"
  [badgeSeverity]="badgeSeverity"
  [size]="size"
  [pTooltip]="label"
  [tooltipPosition]="tooltipPos"
  (onClick)="onClick.emit($event)"
  (onFocus)="onFocus.emit($event)"
  (onBlur)="onBlur.emit($event)"
>
  <mat-icon>{{ icon }}</mat-icon>
</p-button>
